import { useEffect, useState } from "react";
import { PAYMENT_PRESETS } from "@/components/po/POStatus";

// First line of the terms — editable, with quick presets incl. "Credit of N days".
export const PaymentTermsField = ({ value, onChange }) => {
    const credit = /^credit of (\d+) days?/i.exec(value || "");
    const [days, setDays] = useState(credit ? credit[1] : "30");
    useEffect(() => { if (credit) setDays(credit[1]); }, [value]); // eslint-disable-line react-hooks/exhaustive-deps
    const chip = (label, v, tid) => (
        <button type="button" onClick={() => onChange(v)} data-testid={tid}
                className={`px-3 py-1.5 rounded-full text-xs font-bold border transition-colors ${value === v ? "bg-emerald-600 text-white border-emerald-600" : "bg-white border-slate-200 text-slate-700 hover:border-emerald-500"}`}>{label}</button>
    );
    return (
        <div data-testid="po-payment-terms">
            <label className="hdb-label">1. Payment terms</label>
            <div className="flex flex-wrap items-center gap-2 mb-2">
                {PAYMENT_PRESETS.map((p) => chip(p, p, `po-pay-${p.toLowerCase().replace(/ /g, "-")}`))}
                <span className={`inline-flex items-center gap-1 rounded-full border pl-3 pr-1 py-0.5 text-xs font-bold ${credit ? "bg-emerald-600 text-white border-emerald-600" : "bg-white border-slate-200 text-slate-700"}`}>
                    <button type="button" onClick={() => onChange(`Credit of ${days || 30} days`)} data-testid="po-pay-credit">Credit of</button>
                    <input value={days} inputMode="numeric" onChange={(e) => { const d = e.target.value.replace(/\D/g, "").slice(0, 3); setDays(d); onChange(`Credit of ${d || 0} days`); }}
                           className="w-10 rounded-full text-center text-slate-900 bg-white border border-slate-200 py-0.5" data-testid="po-pay-credit-days"/>
                    <span className="pr-2">days</span>
                </span>
            </div>
            <input className="hdb-input font-semibold" value={value} onChange={(e) => onChange(e.target.value)}
                   placeholder="e.g. Payment on Delivery. No delivery charges" data-testid="po-payment-terms-input"/>
        </div>
    );
};
